export class Address {
    addressLine1: string;
    addressLine2: string;
    locality?: string;
    town: string;
    county: string;
    country?: string;
    postcode: string;

    constructor(props?: { [key in keyof Address]?: Address[key] }) {
        Object.assign(this, props);
    }
}
